import { requestJson } from '@/shared/api/http'
import type { PostCommentsResponse } from '../model/comments'

export async function fetchPostComments(
  postId: string,
  params: { page?: number; limit?: number },
  signal?: AbortSignal,
): Promise<PostCommentsResponse> {
  const qs = new URLSearchParams()
  if (params.page) qs.set('page', String(params.page))
  if (params.limit) qs.set('limit', String(params.limit))
  const suffix = qs.toString()
  return requestJson<PostCommentsResponse>(
    `/api/v1/posts/${postId}/comments${suffix ? `?${suffix}` : ''}`,
    { signal },
  )
}
